import * as angular from 'angular';

import { WidgetBase } from '../models';
import { Helper } from '../../common';
import { alarmsEvolutionWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class AlarmsEvolutionWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration = {};
    exportToCsv: () => angular.IPromise<void>;
    guid: string;
    hasExtendedProperties = false;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    isZoomable = true;
    name = definition.title;
    row = 3;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
    }
}

